<template>
  <div class=" model_container materiaTab">

    <el-form action="javascript:void(0)" label-position="top">
      <el-form-item label="搜索">
        <el-input v-model="keyword" placeholder="请输入素材名称" :clearable="true">
        </el-input>
      </el-form-item>

      <el-form-item label="素材">
        <el-radio-group size="small" @change="search()" v-model="materType">
          <el-radio-button label="全部"></el-radio-button>
          <el-radio-button label="图片"></el-radio-button>
          <el-radio-button label="文本"></el-radio-button>
          <el-radio-button label="表格"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-button type="primary" @click="search()" round native-type="submit" style="display: none;"> 搜索</el-button>
    </el-form>
    <div class="scrollContainer" style="overflow-y: scroll;height: calc(100vh - 300px); margin-top: 15px;">
      <div class="infinite-list" style="scrollbar-width: none;overflow:auto" v-infinite-scroll="getMateriaList"
        :infinite-scroll-distance=500 :infinite-scroll-delay=300 :infinite-scroll-immediate=true
        :infinite-scroll-disabled='loadingFinish'>
        <ul style="width:100%;margin: 0;padding: 0;" class="list">

          <el-card v-for="(item, index) in materiaList" :key="index" shadow="hover" class="article_card">
            <div class="title" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;    max-width: 305px;">
              <span :class="'tag ' + item.materType">{{ item.materType }}</span>
              {{ item.name }}
            </div>
            <div class="opreate">
              <el-link :underline="false" @click="preview(item)">
                <span class="link"> 素材预览</span>
              </el-link>
              <el-link :underline="false" @click="insert(item.context)">
                <span class="link">插入正文</span>
              </el-link>
            </div>
          </el-card>

          <div style="clear:both;height: 20px;"></div>
          <div v-if="loadingFinish && materiaList.length === 0" class="mater_empty"></div>
          <template v-if="loadingFinish">
            <div class="noData">
              <i class="iconfont">&#xe629;</i>
              数据加载完毕!
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <span class="icon_run">
                <i class="iconfont">&#xe67b;</i>
              </span>数据加载中...
            </div>
          </template>
        </ul>

      </div>
    </div>
    <el-dialog :append-to-body='true' :show-close=true width="800px" :visible.sync="previewDialogVisible"
      custom-class="previewDialog">
      <span slot="title">
        <h4>{{ curModel.name }}</h4>
        <!-- <div class="summary">{{ curModel.funSummary }}</div> -->

      </span>

      <div class="bgContainer">
        <div class="htmlContainer" v-html="curModel.context">
        </div>
      </div>
      <span slot="footer">
        <div class="previewFooter">
          <!-- <span>数据来源：<a href="http://www.csmar.com/">CSMAR</a></span> -->
          <span style="width: 500px;height: 10px;display: inline-block;">&nbsp;</span>
          <el-button size="mini" type="primary" style="margin-right: 0;"
            @click="insert(curModel.context)">插入正文</el-button>
        </div>

      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: ['articleInfo'],
  components: {
  },
  name: 'bindMobile',
  data: function () {
    return {
      carTypes: [],
      loadingFinish: false,
      previewDialogVisible: false,
      defaultImg: '../assets/imgs/addImgBtn.png',
      materiaList: [],
      materType: '全部',
      keyword: '',
      curModel: {},
      curId: -1

    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {
    insert (val) {
      this.previewDialogVisible = false
      this.$emit('insertHtml', val)
    },
    preview (val) {
      this.curModel = val
      this.previewDialogVisible = true
    },

    search () {
      this.materiaList = []
      this.getMateriaList()
    },
    getMateriaList () {
      console.log('获取素材库')
      let _this = this
      let type = this.materType.replace('全部', '')
      this.axios.post('/webApi/v3/material/pageById', { 'articleId': _this.curId, 'keyword': this.keyword, 'materType': type, '$noLoading': true }).then((response) => {
        _this.materiaList = _this.materiaList.concat(response.data)
        if (_this.pageData && _this.pageData.length > 0) {
          _this.curId = _this.pageData.slice(-1)[0].id
        } else {
          _this.loadingFinish = true
        }
      })
    }

  },
  computed: {

  },
  watch: {

  },
  mounted () {
    this.search()
  }
}

</script>
<style lang="less" scoped>
.materiaTab {
  .list {
    overflow-y: auto;

    .emptyDesc {
      color: rgba(187, 197, 213, 0.59);
      width: 70%;
      margin: auto;
    }

    .item {
      text-align: left;
      padding: 10px;

      .title {
        font-size: 14px;
      }

    }

    .opreate {
      text-align: right;
      margin-top: 10px;

      .link {
        color: #4B8CF7;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/article/materialTab.vue